import React from 'react';

import { Menu, PageTitle } from '../../../components';



const MenuTabs = () => {

  return (

    <div className='menu-page'>

      {/* Page Title */}
      <PageTitle title={'Menu Tabs'} page={'Menu Tabs'} />

      <section className='menu'>
        <Menu /> {/* Menu Component */}
      </section>

    </div>

  );

}

export default MenuTabs;